var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPurchaseWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 18.0344H0.765625V1.65381H17.1462V9.99267H15.7101V3.08616H2.19797V16.6021H11.813V18.0344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3656 6.04834H1.54688V7.48069H16.3656V6.04834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96555 0H4.5332V4.83418H5.96555V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3786 0H11.9463V4.83418H13.3786V0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0325 19.9952C18.1989 19.9952 20.7657 17.4284 20.7657 14.262C20.7657 11.0957 18.1989 8.52881 15.0325 8.52881C11.8662 8.52881 9.29932 11.0957 9.29932 14.262C9.29932 17.4284 11.8662 19.9952 15.0325 19.9952Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9738 17.4588C18.2061 17.2264 18.2061 16.8493 17.9738 16.6131L15.5586 14.1979L15.57 11.7866C15.57 11.6266 15.509 11.478 15.3986 11.3637C15.2881 11.2494 15.1357 11.1885 14.9757 11.1885C14.8157 11.1885 14.6633 11.2494 14.5529 11.3637C14.4424 11.4742 14.3776 11.6228 14.3776 11.7827L14.3662 14.4379V14.4494C14.3662 14.4684 14.3662 14.4836 14.37 14.5027C14.37 14.5103 14.37 14.5179 14.3738 14.5255V14.5332C14.3738 14.5446 14.3776 14.5522 14.3776 14.5598C14.3776 14.5675 14.3814 14.5789 14.3853 14.5865L14.3891 14.5941C14.3891 14.6017 14.3929 14.6094 14.3967 14.617C14.4005 14.6246 14.4005 14.6322 14.4043 14.6398L14.4081 14.6474C14.4119 14.6551 14.4119 14.6627 14.4157 14.6703C14.4195 14.6779 14.4234 14.6855 14.4272 14.6932L14.431 14.7008C14.4348 14.7084 14.4386 14.716 14.4424 14.7236C14.4462 14.7313 14.45 14.7389 14.4538 14.7427L14.4576 14.7503C14.4614 14.7579 14.4653 14.7655 14.4691 14.7732C14.4767 14.7808 14.4805 14.7922 14.4881 14.7998L14.6214 14.7046L14.4919 14.8036C14.4957 14.8074 14.4995 14.8151 14.5034 14.8189C14.5148 14.8341 14.5262 14.8455 14.5376 14.8608L17.1319 17.455C17.3604 17.6912 17.7414 17.6912 17.9738 17.4588Z",
    fill: "#74BF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPurchaseWeb);
export default __webpack_public_path__ + "static/media/icons-purchase-web.7489f3f925489d01d8f68ae1787964a6.svg";
export { ForwardRef as ReactComponent };